import { Col, Input, Label, Row } from "reactstrap";
import { AddCategory, AddTag } from "../../../../../../constants";
import { useAppDispatch } from "../../../../../../reduxToolkit/hooks";
import { setFormValue } from "../../../../../../reduxToolkit/reducers/eCommerce/addProductSlice";
import { AddCategoryList, AddTagList } from "../../../../../../data/applications/ECommerce";
import { Typeahead } from "react-bootstrap-typeahead";

// This component allows users to select a category and add tags to a product.
const AddCategoryTag = () => {
    const dispatch = useAppDispatch();

    return (
      <>
        <Col sm="6">
          <Row className="g-2">
            <Col xs="12">
              <Label className="m-0">
                {AddCategory}
                <span className="text-danger">*</span>
              </Label>
            </Col>
            <Col xs="12">
              <Input type="select" name="category" defaultValue="Toys & games" onChange={(e) => dispatch(setFormValue({ name: "category", value: e.target.value }))}>
                {/* Mapping through AddCategoryList to display a dropdown list of categories */}
                {AddCategoryList.map((item, index) => (
                  <option key={index}>{item}</option>
                ))}
              </Input>
              <p className="f-light">A product can be added to a category</p>
            </Col>
          </Row>
        </Col>
        <Col sm="6">
          <Row className="g-2 product-tag">
            <Col xs="12">
              <Label className="d-block m-0" for="validationServer01" check>
                {AddTag}
                <span className="text-danger"> *</span>
              </Label>
            </Col>
            <Col xs="12">
              <Typeahead id="multiple-typeahead" labelKey="name" multiple options={AddTagList} defaultSelected={["watches"]} />
              <p className="f-light">Products can be tagged</p>
            </Col>
          </Row>
        </Col>
      </>
    );
}
export default AddCategoryTag;